namespace SolovisGateway.Admin.Organizations  {
    export class OrganizationUser {
        id: number;
        fullName: string;
        primaryEmail: string;
        code: string;
        isLoginDisabled: boolean;
        isAccountLocked: boolean;
        requireMfa: boolean;
        contactEmail: string;

        constructor(data?) {
            if (data) {
                this.id = data.id;
                this.fullName = data.fullName;
                this.primaryEmail = data.primaryEmail;
                this.code = data.code;
                this.isLoginDisabled = data.isLoginDisabled;
                this.isAccountLocked = data.isAccountLocked;
                this.requireMfa = data.requireMfa;
                this.contactEmail = data.contactEmail;
            }
        }
    }
}